import { notification } from "antd";
import type { ArgsProps } from "antd/es/notification";

export type NotificationType = "success" | "error" | "info" | "warning";

type NotificationPlacement = "top" | "topLeft" | "topRight" | "bottom" | "bottomLeft" | "bottomRight";

interface NotificationConfig extends ArgsProps {
  type?: NotificationType;
  message: string;
  description?: string;
  placement?: NotificationPlacement;
  duration?: number;
}

class Notification {
  private static defaultConfig = {
    placement: "topRight" as NotificationPlacement,
    duration: 3,
  };

  static show(options: NotificationConfig): void {
    const { type = "info", message, ...rest } = options;
    notification[type]({ message, ...rest });
  }

  static success(config: NotificationConfig): void {
    notification.success({
      ...this.defaultConfig,
      ...config,
    });
  }

  static error(config: NotificationConfig): void {
    notification.error({
      ...this.defaultConfig,
      ...config,
    });
  }

  static info(config: NotificationConfig): void {
    notification.info({
      ...this.defaultConfig,
      ...config,
    });
  }

  static warning(config: NotificationConfig): void {
    notification.warning({
      ...this.defaultConfig,
      ...config,
    });
  }

  static destroy(): void {
    notification.destroy();
  }
}

export default Notification;
